import { getFileName } from "./getFileName";

class MetaBall {
  constructor(metaBall) {
    this.metaBall = metaBall;
    this.metaBallImage = this.metaBall.querySelector("img");
    this.direction = undefined;
    this.x = undefined;
    this.y = undefined;
    this.position = undefined;
    this.effectDuration = 1250;
    this.initialize();
  }
  initialize() {
    this.setPosition();
    this.addScrollEvent();
  }
  setPosition() {
    const self = this;
    self.position = document.documentElement.scrollTop;
  }
  addScrollEvent() {
    const self = this;
    window.addEventListener("scroll", function () {
      const _position = document.documentElement.scrollTop;

      // 方向を判定
      if (self.position < _position) {
        self.direction = "down";
      }
      if (self.position > _position) {
        self.direction = "up";
      }

      // 画像を差し替える
      if (getFileName(self.metaBallImage.src) === `ball.png`) {
        self.metaBallImage.src = `../assets/img/metaverse/ball02.png`;
      } else {
        self.metaBallImage.src = `../assets/img/metaverse/ball.png`;
      }

      self.position = _position;

      // エフェクトを追加
      if (window.pageYOffset > self.metaBall.getBoundingClientRect().top) {
        self.addEffect(self.direction, self);
      }
    });
  }
  addEffect(direction, self = this) {
    self.metaBall.classList.add(`is-${direction}`);
    // 既存のタイマーを削除
    clearTimeout(self.timer);
    self.timer = setTimeout(() => {
      self.metaBall.classList.remove(`is-${direction}`);
    }, this.effectDuration);
    if (direction === "up") {
      self.metaBall.classList.remove(`is-down`);
    } else {
      self.metaBall.classList.remove(`is-up`);
    }
  }
}

const HandleMetaBall = () => {
  const metaBall = document.getElementById("js-metaBall");
  if (metaBall) {
    new MetaBall(metaBall);
  }
};

export default HandleMetaBall;



// WEBPACK FOOTER //
// ./src/recruit/js/metaBall.js